import React, { useEffect, useRef } from 'react';
import { Form, InputNumber, Select, Row, Col, Card, Button,  Switch, notification } from 'antd'; //Tag,
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons'; //DeleteOutlined
import { type FormInstance, type FormListFieldData } from 'antd/es/form';
import AnimatedDiv from '../../../../../common/components/AnimatedDiv/AnimatedDiv';
import CompanyServiceItemRow from './CompanyServiceItemRow';
import { type ServiceType } from '../../../types/insurancePlanTypes';

const { Option } = Select;

interface ServiceTypeCardProps {
  form: FormInstance;
  categoryName: number;
  serviceName: number;
  serviceRestField: FormListFieldData;
  removeService: (index: number) => void;
  serviceTypesOptions: { label: string; value: number }[] | undefined;
  isLoadingServiceTypes: boolean;
  serviceCategoriesOptions: { label: string; labelAr?: string; value: number }[] | undefined;
    serviceCategoryItemsByCategory: Record<number, { label: string; labelAr?: string; value: number }[]>;
    isLoadingServiceCategories: boolean;
    currencyISOCode: string | undefined;
    updateCoverageAmount: (
        form: FormInstance,
        categoryIndex: number
    ) => void;
}

const ServiceTypeCard: React.FC<ServiceTypeCardProps> = ({
  form,
  categoryName,
  serviceName,
  serviceRestField,
  //removeService,
  serviceTypesOptions,
  isLoadingServiceTypes,
  serviceCategoriesOptions,
    serviceCategoryItemsByCategory,
    isLoadingServiceCategories,
    currencyISOCode,
    updateCoverageAmount
}) => {
  const { t } = useTranslation();
  const applyCoShare = Form.useWatch(['planCategories', categoryName, 'serviceTypes', serviceName, 'applyCoShare'], form);
  const percentage = Form.useWatch(['planCategories', categoryName, 'serviceTypes', serviceName, 'percentage'], form);
  const coverageAmount = Form.useWatch(['planCategories', categoryName, 'coverageAmount'], form);
  const isInitialMount = useRef(true);
  useEffect(() => {
   
 
    if (percentage && coverageAmount) {
      const amount = (coverageAmount * percentage) / 100;
      form.setFieldsValue({
        planCategories: {
          [categoryName]: {
            serviceTypes: {
              [serviceName]: {
                amount: amount,
              },
            },
          },
        },
      });
    }
  }, [percentage, coverageAmount, form, categoryName, serviceName]);
//  new code
  useEffect(() => {
    if (coverageAmount) {
      const amount = (coverageAmount * 100) / 100;
      form.setFieldsValue({
        planCategories: {
          [categoryName]: {
            serviceTypes: {
              [serviceName]: {
                amount: amount,
              },
            },
          },
        },
      });
    }
  }, [coverageAmount, form, categoryName, serviceName]);
//  end code
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
 
    if (!applyCoShare) {
      form.setFieldsValue({
        planCategories: {
          [categoryName]: {
            serviceTypes: {
              [serviceName]: {
                coShare: undefined,
              },
            },
          },
        },
      });
    }
  }, [applyCoShare, form, categoryName, serviceName]);

  const handleAddServiceItem = async (
    add: (defaultValue?: Record<string, unknown>, insertIndex?: number) => void,
    serviceName: number,
  ) => {
    const serviceItems = form.getFieldValue(['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems']) || [];
    const lastServiceItemIndex = serviceItems.length - 1;

    if (lastServiceItemIndex >= 0) {
      try {
        await form.validateFields([
          ['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems', lastServiceItemIndex, 'serviceCategoryId'],
          ['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems', lastServiceItemIndex, 'serviceCategoryItemIds'],
          ['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems', lastServiceItemIndex, 'amount'],
          ['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems', lastServiceItemIndex, 'coShare'],
          ['planCategories', categoryName, 'serviceTypes', serviceName, 'serviceItems', lastServiceItemIndex, 'percentage'],
        ]);
      } catch {
        notification.error({
          message: t('Validation Error'),
          description: t('Please correct the errors in the current service item before adding a new one.'),
        });
        return;
      }
    }

    add({
      serviceCategoryId: undefined,
      serviceCategoryItemIds: [],
      percentage: undefined,
      amount: undefined,
      coShare: undefined,
      isAmountCoverage: true,
    });
  };

  return (
    <AnimatedDiv>
      {/* <Card
        // title={
        //   <div>
        //     {t('Service Type')} <Tag>{serviceName + 1}</Tag>
        //   </div>
        // }
        style={{ marginBottom: 16 }}
        extra={
          serviceName !== 0 && (
            <Button
              type="dashed"
              icon={<DeleteOutlined />}
              onClick={() => removeService(serviceName)}
              danger
              disabled={serviceName === 0}
            />
          )
        }
      > */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              {...serviceRestField}
              name={[serviceName, 'serviceTypeId']} style={{ display: 'none' }} initialValue={1}
              label={t('Service Type')}
              rules={[
                { required: true, message: t('Missing service type') },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const serviceTypes = getFieldValue(['planCategories', categoryName, 'serviceTypes']);
                    const count = serviceTypes.filter((item: ServiceType) => item && item.serviceTypeId === value).length;
                    if (count > 1) {
                      return Promise.reject(new Error(t('Service Type must be unique.')));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Select
                placeholder={t('Select service type')}
                loading={isLoadingServiceTypes}
                size="large"
                showSearch={true}
                filterOption={(input, option) =>
                  String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {serviceTypesOptions?.map(st => (
                  <Option key={st.value} value={st.value} label={st.label}>
                    {st.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ display: 'none' }}>
          <Col span={6}>
            <Form.Item {...serviceRestField} name={[serviceName, 'percentage']} label={t('Percentage')} initialValue={100} labelCol={{ style: { display: 'none' } }} wrapperCol={{ style: { display: 'none' } }}
            rules={[
              {
                validator: (_, value) =>
                  value !== undefined && value > 100
                    ? Promise.reject(new Error(t('Percentage cannot be more than 100')))
                    : Promise.resolve(),
              },
            ]}
            >
              <InputNumber min={0} max={100} style={{ width: '100%' }} size="large" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...serviceRestField} name={[serviceName, 'amount']} label={t('Amount')}>
              <InputNumber disabled style={{ width: '100%' }} size="large" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              {...serviceRestField}
              name={[serviceName, 'applyCoShare']}
              label={t('Apply Co-Share')}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          {applyCoShare && (
            <Col span={6}>
                <Form.Item {...serviceRestField} name={[serviceName, 'coShare']} label={t('Co-Share (%)')}
                rules={[
                    {
                        validator: (_, value) =>
                            value !== undefined && value < 0 || value > 100
                                ? Promise.reject(new Error(t('Co-Share must be equal or greater than 0 and less than or equal to 100')))
                                : Promise.resolve(),
                    },
                ]}

                >
                <InputNumber min={0} max={100} style={{ width: '100%' }} size="large" />
              </Form.Item>
            </Col>
          )}
        </Row>

        <Card title={t('Services')} type="inner">
          <Form.List name={[serviceName, 'serviceItems']}>
            {(itemFields, { add: addItem, remove: removeItem }) => (
              <>
                <div
                  style={{
                    background: '#fff',
                    borderRadius: 8,
                    border: '1px solid #e5e7eb',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '32px 1.1fr 1.1fr 130px 130px auto',
                      gap: 12,
                      padding: '10px 12px',
                      background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                      borderBottom: '2px solid #e5e7eb',
                      fontSize: 12,
                      fontWeight: 600,
                      color: 'rgba(0,0,0,0.88)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    <div>#</div>
                    <div>{t('Main Service')}</div>
                    <div>{t('Sub Services')}</div>
                    <div>{t('Co-Share (%)')}</div>
                    <div>{t('Amount')}</div>
                    <div style={{ width: 32 }} />
                  </div>

                  {itemFields.length === 0 ? (
                    <div style={{ padding: '32px 16px', textAlign: 'center' }}>
                      <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 8 }}>
                        {t('No services added yet.')}
                      </div>
                      <div style={{ fontSize: 12, color: '#d1d5db' }}>
                        {t('Click the button below to add your first service')}
                      </div>
                    </div>
                  ) : (
                    itemFields.map((field, itemName) => (
                      <CompanyServiceItemRow
                        key={field.key}
                        field={field}
                        itemName={itemName}
                        totalItems={itemFields.length}
                        serviceName={serviceName}
                        categoryName={categoryName}
                        form={form}
                        removeItem={removeItem}
                        isLoadingServiceCategories={isLoadingServiceCategories}
                        serviceCategoriesOptions={serviceCategoriesOptions}
                        serviceCategoryItemsByCategory={serviceCategoryItemsByCategory}
                        currencyISOCode={currencyISOCode}
                        updateCoverageAmount={updateCoverageAmount}
                      />
                    ))
                  )}

                  <div style={{ padding: '12px', background: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
                    <Button
                      type="dashed"
                      onClick={() => handleAddServiceItem(addItem, serviceName)}
                      icon={<PlusOutlined />}
                      block
                      style={{
                        height: 36,
                        borderColor: '#d1d5db',
                        color: '#0891B2',
                        fontWeight: 500,
                      }}
                    >
                                      {t('Add Service')}
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Form.List>
        </Card>
      {/* </Card> */}
    </AnimatedDiv>
  );
};

export default ServiceTypeCard;